import { css } from '@emotion/react';

export const floatingCareroom = css`
    max-height: calc(100vh - 233px);
    height: 450px;
    width: 340px;
    display: flex;
    position: fixed;
    right: 6%;
    bottom: 0;
    background-color: #ffffff;
    border-radius: 12px;
    box-shadow: 0 2px 30px 0 #bfc9d9;
    transition: all 0.2s ease-in-out 0s;
    transform: translateY(-40px);
    opacity: 1;
    z-index: 1100;

    @media only screen and (max-width: 768px) {
        width: 100vw !important;
        height: 100vh !important;
        max-height: 100vh !important;
        right: 0 !important;
        bottom: 0 !important;
        top: 0 !important;
        left: 0 !important;
        border-radius: 0 !important;
        transform: none !important;
        box-shadow: none !important;
        z-index: 99999 !important;
    }
`;

export const floatingWrapper = css`
    display: flex;
    position: relative;
    width: 100%;
    height: 100%;
`;

export const chatroomContainer = css`
    width: 100%;
    display: flex;
    flex-direction: column;
    height: 100%;
`;

export const topist = css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-height: 56px;
    height: 56px;
    padding: 10px 8px 10px 16px;
    box-shadow: rgba(0, 0, 0, 0.05) 0px 2px 4px 0px;
    flex: 0 0 auto;
`;

export const chatUserWrapper = css`
    display: flex;
    align-items: center;
    gap: 10px;
    min-width: 0;

    .user-info {
        min-width: 0;

        .user-name p {
            margin: 0;
            font-weight: 700;
            font-size: 14px;
            color: #31353b;
            line-height: 20px;
        }

        > p {
            margin: 0;
            font-size: 12px;
            color: #8d96aa;
            line-height: 16px;
        }
    }
`;

export const closeWrapper = css`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    height: 44px;
    padding-right: 8px;
    cursor: pointer;
    color: #8d96aa;
    font-size: 16px;
`;

export const chatroom = css`
    flex: 1 1 auto;
    overflow-y: auto;
    padding: 12px 16px;
    background: #fafafa;
    position: relative;
`;

export const emptyWrapper = css`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    padding: 24px;
`;

export const dayBreak = css`
    display: flex;
    justify-content: center;
    margin: 12px 0;

    span {
        background: #e6e9ef;
        color: #6d7588;
        font-size: 11px;
        padding: 2px 10px;
        border-radius: 10px;
    }
`;

export const chatItem = css`
    display: flex;
    margin-bottom: 10px;

    &.mine {
        justify-content: flex-end;
    }

    &.theirs {
        justify-content: flex-start;
    }
`;

export const chatBubble = css`
    max-width: 80%;
    background: #ffffff;
    border-radius: 12px;
    padding: 8px 12px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
    word-break: break-word;

    .mine & {
        background: #e8f8f9;
    }

    .message-text {
        margin: 0;
        font-size: 13px;
        line-height: 18px;
        color: #31353b;
        white-space: pre-wrap;
    }

    .message-image {
        max-width: 180px;
        border-radius: 8px;
        display: block;
        margin-bottom: 6px;
        cursor: pointer;
    }

    .time {
        display: block;
        margin-top: 4px;
        font-size: 10px;
        color: #8d96aa;
        text-align: right;
    }
`;

export const composer = css`
    flex: 0 0 auto;
    border-top: 1px solid #f0f3f7;
    padding: 8px 12px;
    display: flex;
    align-items: flex-end;
    gap: 8px;
    background: #ffffff;
`;

export const uploadBtn = css`
    color: #8d96aa;
    font-size: 18px;
    cursor: pointer;
    line-height: 1;
    padding: 6px 0;
`;

export const sendBtn = css`
    border: none;
    background: #009faa;
    color: #ffffff;
    border-radius: 8px;
    padding: 8px 12px;
    cursor: pointer;
    font-size: 12px;
    font-weight: 600;

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
`;

export const centerSpin = css`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
`;
